import { useMemo, useState } from 'react';
import { DeliveryStatusType } from 'molecules/DeliveryStatus';
import {
  IAdaptedListProduct,
  IAdaptedProduct,
} from 'commerce/scayle/utils/adapter/types';

export const useProductConfig = (
  product: IAdaptedProduct | IAdaptedListProduct,
  referenceKey: string,
) => {
  const { variants } = product;
  const hasSizes = Number(product.size?.length) > 1;
  const [selectedVariant, setSelectedVariant] = useState<string>(
    hasSizes && product.referenceKey === referenceKey ? '' : referenceKey,
  );

  const variant = useMemo(
    () =>
      variants?.find(({ referenceKey }) => referenceKey === selectedVariant) ||
      variants?.[0],
    [selectedVariant, variants],
  );

  const deliveryStatus = useMemo(
    () =>
      variant?.stock && variant.stock.quantity < 1
        ? DeliveryStatusType.NOT_AVAILABLE
        : DeliveryStatusType.AVAILABLE,
    [variant],
  );

  return {
    hasSizes,
    variants,
    variant,
    deliveryStatus,
    setSelectedVariant,
  };
};
